import { useCallback } from 'react';
import { setBottomSheetVisible } from '@guuru/chat-web';

const useBottomSheet = function () {
  const open = useCallback(() => {
    setBottomSheetVisible(true);
  }, []);
  return { openBottomSheet: open };
};

export default useBottomSheet;
